var _style, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg512Square(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#19174B;}\r\n\t.st1{fill:#E42E75;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M421.24,511.88H90.76C40.64,511.88,0,471.24,0,421.11L0,90.64C0,40.51,40.64-0.13,90.76-0.13h330.47 c50.13,0,90.76,40.64,90.76,90.76v330.47C512,471.24,471.36,511.88,421.24,511.88z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M344.74,168.36H167.26c-18.92,0-34.26,15.34-34.26,34.26s15.34,34.26,34.26,34.26h177.48 c18.92,0,34.26-15.34,34.26-34.26S363.66,168.36,344.74,168.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,265.4c-21.54,0-39,17.46-39,39v0c0,21.54,17.46,39,39,39s39-17.46,39-39v0 C295,282.86,277.54,265.4,256,265.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg512Square);
export default __webpack_public_path__ + "static/media/512square.99cc4fa872344615c2e31b78a9cb8491.svg";
export { ForwardRef as ReactComponent };